module.exports = __webpack_public_path__ + "static/media/star_009AEE.16ae2225.svg";